import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "form", "customRange"]

  selectPreset(event) {
    const button = event.currentTarget
    this.startDateTarget.value = button.dataset.start
    this.endDateTarget.value = button.dataset.end
    this.customRangeTarget.classList.add("hidden")
    this.formTarget.requestSubmit()
  }

  showCustomRange() {
    this.customRangeTarget.classList.remove("hidden")
    this.startDateTarget.focus()
  }
}
